import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'Was kostet Close CRM selbst?',
  answer: 'Close CRM bietet verschiedene Pläne ab $49/Nutzer/Monat. Die genauen Kosten hängen von Ihrer Teamgröße und den benötigten Features ab. Wir beraten Sie gerne, welcher Plan für Sie optimal ist. Unsere Implementierungskosten sind davon unabhängig und einmalig.'
}, {
  question: 'Wie lange dauert die Implementierung?',
  answer: 'Je nach Komplexität dauert eine typische Implementierung 2-4 Wochen. Einfache Setups können in einer Woche abgeschlossen sein, während Enterprise-Projekte mit vielen Integrationen bis zu 6 Wochen dauern können. Wir geben Ihnen im Erstgespräch eine genaue Zeitschätzung.'
}, {
  question: 'Können Sie unsere bestehenden Daten migrieren?',
  answer: 'Ja, wir migrieren Daten aus praktisch jedem System – Excel, HubSpot, Salesforce, Pipedrive und viele mehr. Die Migration umfasst Kontakte, Deals, Aktivitäten und E-Mail-Historie. Wir stellen sicher, dass keine Daten verloren gehen.'
}, {
  question: 'Brauchen wir technisches Know-how?',
  answer: 'Nein. Wir übernehmen die komplette technische Einrichtung. Ihr Team muss nur Close CRM bedienen können – und das bringen wir Ihnen bei. Für laufende Änderungen können Sie uns jederzeit kontaktieren oder unser Managed Service nutzen.'
}, {
  question: 'Was passiert nach der Implementierung?',
  answer: 'Je nach Paket erhalten Sie 14-365 Tage Support. In dieser Zeit beantworten wir Fragen, beheben Probleme und optimieren Prozesse. Danach können Sie auf unseren Managed Service upgraden oder uns bei Bedarf stundenweise buchen.'
}, {
  question: 'Können Sie Close mit unseren anderen Tools verbinden?',
  answer: 'Ja, wir integrieren Close mit praktisch jedem Tool – von E-Mail-Marketing (Mailchimp, ActiveCampaign) über Buchhaltung (DATEV, lexoffice) bis hin zu Custom-APIs. Wir nutzen native Integrationen, Zapier oder entwickeln Custom-Lösungen.'
}, {
  question: 'Was ist, wenn wir nicht zufrieden sind?',
  answer: 'Wir bieten eine 30-tägige Geld-zurück-Garantie. Wenn Sie innerhalb von 30 Tagen nach Go-Live nicht zufrieden sind, erstatten wir Ihnen den vollen Betrag. Ohne Diskussion, ohne Kleingedrucktes.'
}, {
  question: 'Arbeiten Sie nur mit bestimmten Branchen?',
  answer: 'Nein, wir arbeiten branchenübergreifend. Unsere Kunden kommen aus SaaS, Beratung, Agenturen, Fertigung, Finanzdienstleistungen und vielen anderen Bereichen. Close CRM ist flexibel genug für jede B2B-Vertriebsorganisation.'
}, {
  question: 'Wie unterscheiden Sie sich von anderen CRM-Agenturen?',
  answer: 'Wir sind 100% auf Close CRM spezialisiert – keine Ablenkung durch andere Systeme. Das bedeutet tiefere Expertise, schnellere Implementierung und bessere Ergebnisse. Außerdem garantieren wir messbare ROI und bieten eine Geld-zurück-Garantie.'
}, {
  question: 'Können wir erst ein Beratungsgespräch führen?',
  answer: 'Absolut! Wir bieten ein kostenloses 60-minütiges Strategiegespräch an. Dabei analysieren wir Ihre aktuelle Situation, besprechen Ihre Ziele und zeigen auf, wie Close CRM Ihnen helfen kann. Keine Verpflichtung, kein Verkaufsdruck.'
}];
export function FAQ() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 lg:py-32 bg-[#0a0a0a]" id="faq" ref={ref} data-id="element-65">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-66">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-67">
          <span className="inline-block px-4 py-1.5 rounded-full bg-[#0ea5e9]/10 text-[#0ea5e9] text-sm font-medium mb-6" data-id="element-68">
            FAQ
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight" data-id="element-69">
            Häufig gestellte Fragen
          </h2>
          <p className="mt-6 text-lg text-gray-400" data-id="element-70">
            Alles, was Sie über unsere Close CRM Implementierung wissen müssen.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="space-y-4" data-id="element-71">
          {faqs.map((faq, index) => <div key={index} className="rounded-xl bg-[#1a1a1a] border border-white/5 overflow-hidden" data-id="element-72">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left" data-id="element-73">
                <span className="text-white font-medium pr-4" data-id="element-74">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-gray-400 flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-75" />
              </button>
              <div className={`overflow-hidden transition-all duration-200 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`} data-id="element-76">
                <p className="px-6 pb-6 text-gray-400 leading-relaxed" data-id="element-77">
                  {faq.answer}
                </p>
              </div>
            </div>)}
        </motion.div>

        {/* Still have questions */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="mt-12 text-center" data-id="element-78">
          <p className="text-gray-400 mb-4" data-id="element-79">
            Noch Fragen? Schreiben Sie uns auf WhatsApp.
          </p>
          <a href="https://wa.me/491745444423" target="_blank" rel="noopener noreferrer" className="text-[#0ea5e9] font-semibold hover:underline" data-id="element-80">
            +49 174 544 4423
          </a>
        </motion.div>
      </div>
    </section>;
}